import axios from "axios";

export default function useAxios() {
   let api = axios.create({
      baseURL: import.meta.env.VITE_BASE_API_URL,
      headers: {
         "Content-Type": "application/json",
         Accept: "application/json",
      },
      withCredentials: true,
      withXSRFToken: true,
   });

   async function csrf() {
      return await api.get("/sanctum/csrf-cookie");
   }

   return {
      api,
      csrf,
   };
}
